import { render, staticRenderFns } from "./LineHeading.vue?vue&type=template&id=19425a46&"
import script from "./LineHeading.vue?vue&type=script&lang=js&"
export * from "./LineHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports